export { default as authReducer, logout, setAuthInfo } from './authSlice';
export { login } from './authThunks';

export const selectAuthError = (state: { auth: { error: string | null } }) =>
	state.auth.error;
export const selectAuthAccess = (state: { auth: { access: string | null } }) =>
	state.auth.access;
export const selectAuthRefresh = (state: {
	auth: { refresh: string | null };
}) => state.auth.refresh;
